import { IUserDefinedInformationSource } from "./IUserDefinedInformationSource";

export interface IUserDefinedInformationSourceSpecifiable {
  userDefinedInformationSource: IUserDefinedInformationSource;
}

export function instanceOfIUserDefinedInformationSourceSpecifiable(instance: any): instance is IUserDefinedInformationSourceSpecifiable {
  return instance
    && (instance.userDefinedInformationSource !== undefined);
}
